import { FETCH_INVOICES } from '../actionTypes';

const initialState = {
};

export default function(state = initialState, action=null){
  if(action.type ===FETCH_INVOICES) {
    return {
      ...state,
      ...action.payload
    };
  } else {
      return state;
  }
}




// WEBPACK FOOTER //
// ./src/store/reducers/invoices.js